import * as normalize from 'utils/normalize';

import getPatientName from 'utils/print/getPatientName';
import getInsuranceID from 'utils/print/getInsuranceID';
import getPatientDob1 from 'utils/print/getPatientDob1';
import getPatientDob2 from 'utils/print/getPatientDob2';
import getPatientDob3 from 'utils/print/getPatientDob3';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getSupplierName from 'utils/print/getSupplierName';
import getSupplierPhone1 from 'utils/print/getSupplierPhone1';
import getSupplierPhone2 from 'utils/print/getSupplierPhone2';
import getSupplierPhone3 from 'utils/print/getSupplierPhone3';
import getSupplierNSCorNPI from 'utils/print/getSupplierNSCorNPI';
import getSupplierFax1 from 'utils/print/getSupplierFax1';
import getSupplierFax2 from 'utils/print/getSupplierFax2';
import getSupplierFax3 from 'utils/print/getSupplierFax3';
import getFacilityAddress from 'utils/print/getFacilityAddress';
import getInquiringProviderTaxID from 'utils/print/getInquiringProviderTaxID';
import getPrescriberName from 'utils/print/getPrescriberName';
import getPrescriberNPI from 'utils/print/getPrescriberNPI';
import getPrescriberPhone1 from 'utils/print/getPrescriberPhone1';
import getPrescriberPhone2 from 'utils/print/getPrescriberPhone2';
import getPrescriberPhone3 from 'utils/print/getPrescriberPhone3';
import getPrescriberFullAddress from 'utils/print/getPrescriberFullAddress';
import getOrderLineHCPCSCodeDescription from 'utils/print/getOrderLineHCPCSCodeDescription';
import getOrderLineUnits from 'utils/print/getOrderLineUnits';

const PriorAuthorizationTemplateFidelisAuthorizationRequest = {
  ID: 23,
  Name: 'Fidelis Authorization Request',
  Type: 'Prior Authorization Template',
  Format: 'letter',
  Orientation: 'p',
  OrderLineMax: 7,
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Prior-Authorization-Template-Fidelis-Authorization-Request/1.js',
      fields: [
        {
          name: 'Fax',
          type: 'text',
          x: 65,
          y: 59.5,
          width: 44,
          normalize: normalize.phone,
        },
        {
          name: 'Questions',
          type: 'text',
          x: 132,
          y: 59.5,
          width: 44,
          normalize: normalize.phone,
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 10,
          y: 76.5,
          width: 69,
        },
        {
          name: 'Patient ID',
          type: 'text',
          getValue: getInsuranceID,
          x: 85,
          y: 76.5,
          width: 59,
        },
        {
          name: 'Patient DOB 1',
          type: 'text',
          getValue: getPatientDob1,
          x: 160,
          y: 76.5,
          width: 10,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'Patient DOB 2',
          type: 'text',
          getValue: getPatientDob2,
          x: 175,
          y: 76.5,
          width: 10,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'Patient DOB 3',
          type: 'text',
          getValue: getPatientDob3,
          x: 191,
          y: 76.5,
          width: 15,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'ICD-10 Diagnosis Code 1',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 0 }),
          x: 13,
          y: 86,
          width: 16,
          normalize: normalize.hcpcCode,
        },
        {
          name: 'ICD-10 Diagnosis Code 2',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 1 }),
          x: 34,
          y: 86,
          width: 16,
          normalize: normalize.hcpcCode,
        },
        {
          name: 'ICD-10 Diagnosis Code 3',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 2 }),
          x: 56,
          y: 86,
          width: 16,
          normalize: normalize.hcpcCode,
        },
        {
          name: 'ICD-10 Diagnosis Code 4',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 3 }),
          x: 79,
          y: 86,
          width: 16,
          normalize: normalize.hcpcCode,
        },
        {
          name: 'ICD-10 Diagnosis Code 5',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 4 }),
          x: 101,
          y: 86,
          width: 16,
          normalize: normalize.hcpcCode,
        },
        {
          name: 'ICD-10 Diagnosis Code 6',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 5 }),
          x: 123,
          y: 86,
          width: 16,
          normalize: normalize.hcpcCode,
        },
        {
          name: 'ICD-10 Diagnosis Code 7',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 6 }),
          x: 145,
          y: 86,
          width: 16,
          normalize: normalize.hcpcCode,
        },
        {
          name: 'ICD-10 Diagnosis Code 8',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 7 }),
          x: 168,
          y: 86,
          width: 16,
          normalize: normalize.hcpcCode,
        },
        {
          name: 'SERVICING PROVIDER Name',
          type: 'text',
          getValue: getSupplierName,
          x: 10,
          y: 101,
          width: 52,
        },
        {
          name: 'SERVICING PROVIDER Address',
          type: 'text',
          getValue: getFacilityAddress,
          x: 67,
          y: 101,
          width: 71,
        },
        {
          name: 'SERVICING PROVIDER Phone 1',
          type: 'text',
          getValue: getSupplierPhone1,
          x: 146,
          y: 101,
          width: 10,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'SERVICING PROVIDER Phone 2',
          type: 'text',
          getValue: getSupplierPhone2,
          x: 162,
          y: 101,
          width: 11,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'SERVICING PROVIDER Phone 3',
          type: 'text',
          getValue: getSupplierPhone3,
          x: 179,
          y: 101,
          width: 28,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'SERVICING PROVIDER Tax ID',
          type: 'text',
          getValue: getInquiringProviderTaxID,
          x: 10,
          y: 110,
          width: 52,
        },
        {
          name: 'SERVICING PROVIDER NPI',
          type: 'text',
          getValue: getSupplierNSCorNPI,
          x: 67,
          y: 110,
          width: 71,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'SERVICING PROVIDER Fax 1',
          type: 'text',
          getValue: getSupplierFax1,
          x: 146,
          y: 110,
          width: 10,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'SERVICING PROVIDER Fax 2',
          type: 'text',
          getValue: getSupplierFax2,
          x: 162,
          y: 110,
          width: 11,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'SERVICING PROVIDER Fax 3',
          type: 'text',
          getValue: getSupplierFax3,
          x: 179,
          y: 110,
          width: 28,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'Ordering Doctor Name',
          type: 'text',
          getValue: getPrescriberName,
          x: 10,
          y: 121.5,
          width: 52,
        },
        {
          name: 'Ordering Provider NPI',
          type: 'text',
          getValue: getPrescriberNPI,
          x: 67,
          y: 121.5,
          width: 71,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'Ordering Provider Address',
          type: 'text',
          getValue: getPrescriberFullAddress,
          x: 144,
          y: 121.5,
          width: 64,
        },
        {
          name: 'Ordering Provider IPA Affiliation',
          type: 'text',
          x: 60,
          y: 129,
          width: 77,
        },
        {
          name: 'Ordering Provider Phone 1',
          type: 'text',
          getValue: getPrescriberPhone1,
          x: 146,
          y: 130,
          width: 10,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'Ordering Provider Phone 2',
          type: 'text',
          getValue: getPrescriberPhone2,
          x: 162,
          y: 130,
          width: 11,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'Ordering Provider Phone 3',
          type: 'text',
          getValue: getPrescriberPhone3,
          x: 179,
          y: 130,
          width: 28,
          normalize: normalize.positiveNumber,
        },
        ...[0, 1, 2, 3, 4, 5, 6].reduce((accumulator, currentValue) => {
          const y = 146 + (currentValue * 8.75);
          return [
            ...accumulator,
            {
              name: `HCPC Code and descriptions ${currentValue}`,
              type: 'text',
              getValue: props =>
                getOrderLineHCPCSCodeDescription({ ...props, index: currentValue }),
              x: 12,
              y,
              width: 125,
            },
            {
              name: `Qty ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineUnits({ ...props, index: currentValue }),
              x: 143,
              y,
              width: 59,
              normalize: normalize.number,
            },
          ];
        }, []),
      ],
    },
  ],
};

export default PriorAuthorizationTemplateFidelisAuthorizationRequest;



// WEBPACK FOOTER //
// ./src/config/documents/Prior-Authorization-Template-Fidelis-Authorization-Request.js